function lifecycle(range) {
  return range?.lifecycle?.status || range?.status || "unknown";
}

export function PlatformAdminPage({
  loading,
  navigate,
  ranges = [],
  setActiveRangeId
}) {
  const activeRanges = ranges.filter((range) => ["trial", "active"].includes(lifecycle(range)));
  const inactiveRanges = ranges.length - activeRanges.length;

  return (
    <div className="ops-page">
      {loading && <div className="status-strip">Loading platform operations...</div>}
      <section className="module-metrics">
        <div>
          <span>Total ranges</span>
          <strong>{ranges.length}</strong>
        </div>
        <div>
          <span>Operational</span>
          <strong>{activeRanges.length}</strong>
        </div>
        <div>
          <span>Inactive</span>
          <strong>{inactiveRanges}</strong>
        </div>
      </section>

      <section className="panel">
        <div className="panel-header">
          <div>
            <h2>Platform Operations</h2>
            <p>Operate across range tenants before drilling into a single range console.</p>
          </div>
        </div>
        <div className="table-like compact-table">
          <div className="table-row table-head">
            <span>Range</span>
            <span>Status</span>
            <span>Public slug</span>
            <span>Open</span>
          </div>
          {ranges.map((range) => (
            <div className="table-row" key={range.rangeId}>
              <span>
                <strong>{range.name}</strong>
                <small>{range.rangeId}</small>
              </span>
              <span>{lifecycle(range)}</span>
              <span>{range.slug || range.publicSlug || "Not set"}</span>
              <span>
                <button
                  type="button"
                  className="secondary-button"
                  onClick={() => {
                    setActiveRangeId(range.rangeId);
                    navigate(`/console/ranges/${range.rangeId}`);
                  }}
                >
                  Open range
                </button>
              </span>
            </div>
          ))}
        </div>
        {ranges.length === 0 && <div className="empty-state">No ranges are available to this signed-in operator.</div>}
      </section>
    </div>
  );
}
